import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { RiskNotice } from "@/components/RiskNotice";

export function ResponsibleGamblingPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Ansvarsfullt spelande" : "Responsible gambling";
  const desc = isSv
    ? "Verktyg, gränser och stödtjänster för ansvarsfullt spelande i Sverige."
    : "Tools, limits and support resources for responsible gambling in Sweden.";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        <div className="card p-5">
          <h2 className="text-lg font-semibold">Spelpaus.se</h2>
          <p className="mt-2 text-sm text-ink-700">
            {isSv
              ? "Stäng av dig från allt spel hos svenska licensierade spelbolag i 1, 3, 6 eller 12 månader."
              : "Self-exclude from all Swedish-licensed gambling for 1, 3, 6 or 12 months."}
          </p>
          <a
            className="mt-3 inline-block btn-primary"
            href="https://www.spelpaus.se/"
            rel="noopener noreferrer"
            target="_blank"
          >
            spelpaus.se
          </a>
        </div>
        <div className="card p-5">
          <h2 className="text-lg font-semibold">Stödlinjen</h2>
          <p className="mt-2 text-sm text-ink-700">
            {isSv
              ? "Stödlinjen erbjuder kostnadsfri och anonym hjälp för dig som spelar för mycket eller är anhörig."
              : "Stödlinjen offers free, anonymous help for problem gamblers and their loved ones."}
          </p>
          <p className="mt-2 text-sm">
            <strong>020-81 91 00</strong>
          </p>
        </div>
        <div className="card p-5">
          <h2 className="text-lg font-semibold">Spelinspektionen</h2>
          <p className="mt-2 text-sm text-ink-700">
            {isSv
              ? "Spelinspektionen är den svenska tillsynsmyndigheten för spel. Här kontrollerar du licens."
              : "Spelinspektionen is the Swedish gambling authority where you can verify a license."}
          </p>
        </div>
      </div>

      <div className="mt-8 grid gap-4">
        <RiskNotice variant="general" />
        <RiskNotice variant="spelpaus" />
        <RiskNotice variant="unlicensed" />
      </div>

      <section className="prose prose-ink mt-8 max-w-none">
        <h2>{isSv ? "Tecken på spelproblem" : "Signs of problem gambling"}</h2>
        <ul>
          <li>{isSv ? "Du spelar mer än du har råd med" : "You gamble more than you can afford"}</li>
          <li>{isSv ? "Du jagar förluster" : "You chase losses"}</li>
          <li>{isSv ? "Du ljuger om ditt spelande" : "You lie about your gambling"}</li>
          <li>{isSv ? "Spelandet påverkar familj eller jobb" : "Gambling affects family or work"}</li>
        </ul>
        <p>
          {isSv
            ? "Om du känner igen dig: stäng av dig på spelpaus.se och kontakta Stödlinjen. Det finns hjälp att få."
            : "If you recognise yourself: self-exclude on spelpaus.se and contact Stödlinjen. Help is available."}
        </p>
      </section>

      <InternalLinks context="responsible" />
    </div>
  );
}
